var _Defs, _ClipPath, _Path, _Path2, _Path3, _Path4, _Path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, Path, ClipPath, Use } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgScottishSeason(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "scottishSeason_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 90 90",
    xmlSpace: "preserve"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Path, {
    id: "scottishSeason_svg__SVGID_1_",
    d: "M0 0h90v90H0z"
  }))), _ClipPath || (_ClipPath = /*#__PURE__*/React.createElement(ClipPath, {
    id: "scottishSeason_svg__SVGID_00000057837507544807651010000006983595129647469973_"
  }, /*#__PURE__*/React.createElement(Use, {
    xlinkHref: "#scottishSeason_svg__SVGID_1_",
    overflow: "visible"
  }))), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M75.9 21C68.8 11.8 57.6 5.8 45 5.8 23.4 5.8 5.8 23.4 5.8 45S23.4 84.2 45 84.2c13 0 24.6-6.4 31.7-16.2l-3.5-3.2C66.9 73.7 56.6 79.5 45 79.5 26 79.5 10.5 64 10.5 45S26 10.5 45 10.5c11.3 0 21.3 5.4 27.6 13.7l3.3-3.2z",
    clipPath: "url(#scottishSeason_svg__SVGID_00000057837507544807651010000006983595129647469973_)",
    fill: "#fff"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M67.2 63.4h-7.7L48.9 48.3H38L33.6 42h22.3c2.2 0 4-2 4-4.5 0-2.4-1.8-4.4-4-4.4H27.3l-4.5-6.3h31.8c3.6 0 6.5 1.1 8.7 3.4 1.9 2 2.9 4.5 2.9 7.4 0 2.4-.9 4.6-2.6 6.5-1.7 1.9-4 3.1-6.9 3.8l10.5 15.5z",
    clipPath: "url(#scottishSeason_svg__SVGID_00000057837507544807651010000006983595129647469973_)",
    fill: "#fff"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M45 90c24.9 0 45-20.1 45-45S69.9 0 45 0 0 20.1 0 45s20.1 45 45 45",
    clipPath: "url(#scottishSeason_svg__SVGID_00000057837507544807651010000006983595129647469973_)",
    fill: "#4d2c91"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "M75.9 21C68.8 11.8 57.6 5.8 45 5.8 23.4 5.8 5.8 23.4 5.8 45S23.4 84.2 45 84.2c13 0 24.6-6.4 31.7-16.2l-3.5-3.2C66.9 73.7 56.6 79.5 45 79.5 26 79.5 10.5 64 10.5 45S26 10.5 45 10.5c11.3 0 21.3 5.4 27.6 13.7l3.3-3.2z",
    clipPath: "url(#scottishSeason_svg__SVGID_00000057837507544807651010000006983595129647469973_)",
    fill: "#fff"
  })), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    d: "M25.9 54.5c1.4 6.3 9.4 10.6 19.6 10.6 10 0 18.5-4 18.5-11.5-.1-3.8-3.3-8.6-13.3-11L44 40.7c-5.6-1.5-6.2-3.5-6.2-4.8 0-3.1 3.5-4.6 7.7-4.6 3.8 0 7.4 1.1 9.2 5.1l8-2.5c-2.4-5.5-8.5-8.9-17.2-8.9-9.5 0-17.2 4.2-17.2 11.1 0 3.3 1.9 8.2 12.7 10.9l6.7 1.7c4.6 1.2 6.8 2.9 6.8 5.2 0 3.1-3.9 4.9-9.3 4.9-5.6 0-9.6-2.4-10.7-5.7l-8.6 1.4z",
    clipPath: "url(#scottishSeason_svg__SVGID_00000057837507544807651010000006983595129647469973_)",
    fill: "#fff"
  })));
}
export default SvgScottishSeason;